import client from './client';

export const authApi = {
  signup(payload) {
    return client.post('/hub/api/v1/signup', payload);
  },
  login(payload) {
    return client.post('/hub/api/v1/sessions', payload);
  },
  me() {
    return client.get('/hub/api/v1/me');
  },
};
